import React from 'react';
import styled from 'styled-components';

import { RED } from '../../config/colors';

const Ellipsis = styled.div`
    display: inline-block;
    position: relative;
    width: 64px;
    height: 11px;
    top: -1px;
    
    div {
        position: absolute;
        top: 0px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: ${RED};
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
        
        &:nth-child(1) {
            left: 6px;
            animation: lds-ellipsis1 0.6s infinite;
        }
        
        &:nth-child(2) {
            left: 6px;
            animation: lds-ellipsis2 0.6s infinite;        
        }
        
        &:nth-child(3) {
            left: 26px;
            animation: lds-ellipsis2 0.6s infinite;
        }
        
        &:nth-child(4) {
            left: 45px;
            animation: lds-ellipsis3 0.6s infinite;
        }
    }
`;

export default class DottedLoader extends React.Component {
    render() {
        return (
            <Ellipsis>
                <div />
                <div />
                <div />
                <div />
            </Ellipsis>
        );
    }
}
